import { Plus } from "@phosphor-icons/react";
import React from "react";
import { Handle, Position } from "reactflow";
import { useHandleConnection } from "./useHandleConnection";
import { HandleId, OutputHandleProps } from "./types.d";

const OUTPUT_VALID_SOURCES: HandleId[] = [HandleId.Input];

const OutputHandle = ({
  isActive,
  colorActive,
  handleId = HandleId.OutputFlow,
  style,
}: OutputHandleProps) => {
  const {
    isDropTarget,
    baseStyle,
    visualStyle,
    handleMouseEnter,
    handleMouseLeave,
  } = useHandleConnection({
    handleId,
    validSourceHandles: OUTPUT_VALID_SOURCES,
    isActive,
    colorActive,
    side: "right",
  });

  return (
    <Handle
      type="source"
      position={Position.Right}
      id={handleId}
      style={{ ...baseStyle, ...style }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div style={visualStyle}>
        <Plus
          pointerEvents="none"
          color={isDropTarget || isActive ? "#fff" : "#667085"}
          size={14}
          weight="bold"
        />
      </div>
    </Handle>
  );
};

export default OutputHandle;
